import { TEXT_CHIP_RENDERING_OPTIONS } from '@iris/modules/module-filters-v2/chips/rendering-options';
import { appendTextQueryParamsFn } from '@iris/modules/module-filters-v2/query-params';
import { IrisFilterPropertyMeta } from './filter-property-meta';
import { filterValueUniversalIsEmpty } from '@iris/modules/module-filters-v2/utils';
import { of } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { StrakitTextComponent } from '@ngx-strakit/cdk/controls';
import { ComponentRef, inject, runInInjectionContext } from '@angular/core';
import { IrisGlobalSandbox } from '@iris/common/redux/global.sandbox';

export function textFilterMeta(
  propertyId: string,
  label: string,
  fieldNames: string | string[] = propertyId,
  isStrict = false,
  hasTextSearchPattern = false,
  method = '',
  useTranslationSearch = false,
): IrisFilterPropertyMeta<string> {
  return {
    propertyId,
    label,
    appendFilterQueryParamsFn: appendTextQueryParamsFn(fieldNames, isStrict, hasTextSearchPattern, method, useTranslationSearch),
    chipRenderingOptions: TEXT_CHIP_RENDERING_OPTIONS,
    filterRenderingOptions: {
      component: StrakitTextComponent,
      getFilterValueFn: (componentInstance: StrakitTextComponent) => componentInstance.outerControl.valueChanges.pipe(
        debounceTime(300),
        distinctUntilChanged(),
      ),
      initComponentFn: (componentRef: ComponentRef<StrakitTextComponent>) => {
        const injector = componentRef.injector;

        runInInjectionContext(injector, () => {
          const globalSandbox = inject(IrisGlobalSandbox);
          const theme = globalSandbox.theme();

          if(theme?.strabagControlsEnabled) {
            componentRef.instance.stylingControlDirective.stylingMode.set('automatized');
            componentRef.instance.stylingControlDirective.noSubscriptBox.set(true);
            componentRef.instance.stylingControlDirective.extraDense.set(true);
          } else {
            componentRef.instance.stylingControlDirective.stylingMode.set('unformed');
          }
        });

        componentRef.instance.showClear = true;

        return of(null);
      },
      setValueFn: (componentInstance: StrakitTextComponent, value: string) => componentInstance.outerControl.patchValue(value ?? null, { emitEvent: false }),
    },
    filterValueIsEmpty: filterValueUniversalIsEmpty,
  };
}
